'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var pureEnhance = _interopDefault(require('@ux/pure-enhance'));
var rehook = require('@team-griffin/rehook');
var styleUtils = require('@ux/style-utils');
var ramdaAdjunct = require('ramda-adjunct');
var qs = require('qs');
var capra = require('@team-griffin/capra');
var reactCSS = _interopDefault(require('reactcss'));
var r = require('ramda');

var baseUrl = 'https://paintbrush.heg-cp.com';

function createPaintbrushUrl(icon, colors) {
  var params = qs.stringify({
    colors: colors
  }, {
    encodeValuesOnly: true,
    indices: false
  });
  return "".concat(baseUrl, "/glyphs/").concat(icon, ".svg?").concat(params);
}

var createPaintbrushUrl$1 = capra.curry2(createPaintbrushUrl);

var capitalLetters = /(?=[A-Z])/;

var camelToLowerCase = function camelToLowerCase(str) {
  return str.split(capitalLetters).join(' ').toLocaleLowerCase();
};

var createGlyphAlt = function createGlyphAlt(icon, alt) {
  return alt || camelToLowerCase(icon);
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var stylesheet = (function (_ref) {
  var _reactCSS;

  var size = _ref.size,
      width = _ref.width,
      height = _ref.height;
  return reactCSS((_reactCSS = {
    default: {
      root: {
        maxWidth: styleUtils.percentage(100),
        height: size,
        width: size
      }
    }
  }, _defineProperty(_reactCSS, styleUtils.modifier('widthSet', true), {
    root: {
      width: width,
      height: 'auto'
    }
  }), _defineProperty(_reactCSS, styleUtils.modifier('heightSet', true), {
    root: {
      width: 'auto',
      height: height
    }
  }), _defineProperty(_reactCSS, styleUtils.modifier('widthHeightSet', true), {
    root: {
      width: width,
      height: height
    }
  }), _reactCSS), [{
    widthSet: !r.isNil(width)
  }, {
    heightSet: !r.isNil(height)
  }, {
    widthHeightSet: r.and(!r.isNil(width), !r.isNil(height))
  }]);
});

var PureGlyph = function PureGlyph(_ref) {
  var styles = _ref.styles,
      icon = _ref.icon,
      color = _ref.color,
      alt = _ref.alt;
  return (// @ts-ignore
    React.createElement("img", {
      src: createPaintbrushUrl$1(icon, color),
      alt: createGlyphAlt(icon, alt),
      style: styles.root,
      loading: "lazy"
    })
  );
};

var enhance = pureEnhance('Glyph', [styleUtils.withStylesHook(stylesheet), rehook.withProps(function (ownerProps) {
  return {
    color: ramdaAdjunct.ensureArray(ownerProps.color)
  };
})]);
var Glyph = enhance(PureGlyph); // eslint-disable-next-line no-underscore-dangle

exports.Glyph = Glyph;
exports.createPaintbrushUrl = createPaintbrushUrl$1;
exports.default = Glyph;
